import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformKeysToCamelCase } from 'helpers/core';
import URLS from 'constants/urls';

const handler = ({ httpClient }, venueId, instructorId) => {
  const endpoint = URLS.ratings.classesRatings(venueId, instructorId);

  return httpClient.get(endpoint).then(({ data }) => transformKeysToCamelCase(data));
};

export default makeEntityScaffold('SAGA.API.CLASSES_RATINGS', handler, {
  defaultKey: (_, venueId, instructorId) => `${venueId}_${instructorId}`,
});
